import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { VoucherService } from "../../../accounts/voucher/shared/voucher.service";
import { Voucher } from "../../voucher/shared/voucher.model";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

@Injectable({
  providedIn: 'root'
})

export class PrintcashbookService {

  selectedVoucher: Voucher;

  constructor(private datePipe: DatePipe,
    private  voucherService : VoucherService, private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  FetchLedgerReports(rptSearchData: any) {

    this.selectedVoucher = new Voucher();

    this.selectedVoucher.ReportName =rptSearchData.ReportName;
    this.selectedVoucher.ToDate =rptSearchData.LedgerToDate;    
    this.selectedVoucher.FromDate =rptSearchData.LedgerFromDate;

    this.selectedVoucher.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedVoucher.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedVoucher.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedVoucher.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedVoucher;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Voucher/Report', body, { headers: headers });
  }

  GenerateReport(rptSearchData: any) {

    this.voucherService.FetchLedgerReports(rptSearchData)
    .toPromise()
    .then(data => {
      
      this.ReportGenerateListHtml(data, rptSearchData, this.datePipe);
    })
    .catch(err => { console.log(err) });
  }

  //--------------------------------------------------  
  ReportGenerateList(VoucherData: any, searchDate: any,datePipe: DatePipe) {

    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {

        if(i==0){
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "240",
              align: "left",
              padding: 0,});}
        else if(i==1){
                HeaderResult.push({
                  id: HeaderName[i],
                  name: HeaderName[i],
                  prompt: HeaderName[i],
                  width: "100",
                  align: "left",
                  padding: 0,});}
        else if(i==2){
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "30",
              align: "left",
              padding: 0,});}
        else if(i==3){
          HeaderResult.push({
            id: HeaderName[i],
            name: HeaderName[i],
            prompt: HeaderName[i],
            width: "150",
            align: "left",
            padding: 0,});}
      else if(i==4 || i==5){
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "60",
              align: "left",
              padding: 0,});}
      else{
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "140",
              align: "left",
              padding: 0,});
          }
      }

    return HeaderResult;
    }

  var headers = createHeaders([
    "Voucher No",
    "Type",
    "-",
    "Ledger",
    "Credit",
    "Debit",
    "Branch"
  ]);


    // Document of 210mm wide and 297mm high
    let pdf = new jsPDF('p', 'pt', 'A4');

    pdf.setProperties({
      title: 'Ledger',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'SRI'
    });

    let todayDate = new Date();

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 210, 40);  // 40 is the height
    pdf.text("Cash Book Between " + 
    datePipe.transform(searchDate.LedgerFromDate, 'dd-MM-yyyy').toString()
     + " and " +  
    datePipe.transform(searchDate.LedgerToDate, 'dd-MM-yyyy').toString(), 160, 60);
    pdf.setLineWidth(1);
    pdf.line(5, 70, 590, 70)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(8);   

    var generateData = function (VoucherData) {

      var result = [];
      var itemData = [{}];     
      // let todayDate = new Date(); 
      // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));

      for (var i = 0; i < VoucherData.length; i += 1) {
        itemData[i] = {
          Id: VoucherData[i].Id.toString(),
          'Voucher No': VoucherData[i].VoucherNumber.toString(),
          'Type': VoucherData[i].Name.toString(),       
          '-': VoucherData[i].ToOrBy.toString(),
          'Ledger': VoucherData[i].Narration.toString(),
          'Credit': VoucherData[i].EntryType == "C " ? (VoucherData[i].Amount.toString()) : "0.00",
          'Debit': VoucherData[i].EntryType == "D " ? (VoucherData[i].Amount.toString()) : "0.00",
          'Branch':  VoucherData[i].CustomerBranchName.toString(),
        };
      }

      for (var i = 0; i < VoucherData.length; i += 1) {
        itemData[i]['Id'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }
      return result;
    };

    pdf.table(5, 80, generateData(VoucherData), headers, { autoSize: false });
    pdf.output('dataurlnewwindow');

  }

  ReportGenerateListHtml(VoucherData : any, searchDate: any, datePipe: DatePipe){

    let pdf = new jsPDF('l', 'pt', 'A4');
    console.log(VoucherData);
    var img = new Image()
    img.src = '../../assets/appimages/SRI.png'
    // var options = {orientation: 'p', unit: 'mm', format: custom};
    // var doc = new jsPDF(options);
    pdf.addImage(img, 'png', 250, 20, 40, 40);
    let todayDate = new Date();

        // Top HEADER
        pdf.setTextColor(0, 0, 0);
        pdf.setFontSize(14);
        pdf.setFont('arial', 'normal');
        pdf.text("Society For Rural Improvements", 310, 20);  // 40 is the height
        pdf.text("Cash Book Between ", 355, 40);
        pdf.text(datePipe.transform(searchDate.LedgerFromDate, 'dd-MM-yyyy').toString()
        + " and " +  
       datePipe.transform(searchDate.LedgerToDate, 'dd-MM-yyyy').toString(), 325, 60);
        pdf.setLineWidth(1);
        pdf.line(5, 70, 850, 70)
        // Top HEADER END 

    // list item to json array
    var itemData = [];
      for (var i = 0; i < VoucherData.length; i += 1) {
        itemData[i] = {
          'No': (i + 1).toString(),
          'VoucherNo': VoucherData[i].VoucherNumber.toString(),
          'Type': VoucherData[i].Name.toString(),       
          'ToOrBy': VoucherData[i].ToOrBy.toString(),
          'Ledger': VoucherData[i].Narration.toString(),
          'Credit': VoucherData[i].EntryType == "C " ? (VoucherData[i].Amount.toString()) : "0.00",
          'Debit': VoucherData[i].EntryType == "D " ? (VoucherData[i].Amount.toString()) : "0.00",
          'Branch':  VoucherData[i].CustomerBranchName.toString(),
        };
      }

      var rows = [];
      // convert json array to Array
      itemData.forEach((element,index,array) => {
        rows.push([element.No, element.VoucherNo, element.Type, element.ToOrBy,
          element.Ledger, element.Credit, element.Debit, element.Debit, element.Branch
        ])
      });

    var columns = [
      {title: "No", dataKey: "No"},
      {title: "Voucher No", dataKey: "VoucherNo"},
      {title: "Type", dataKey: "Type"},
      {title: "", dataKey: "ToOrBy"},
      {title: "Ledger", dataKey: "Ledger"},
      {title: "Credit", dataKey: "Credit"},
      {title: "Debit", dataKey: "Debit"},
      {title: "Branch", dataKey: "Branch"},
      ];

    var body = rows;
    // New Header and Footer Data Include the table
    var y = 2;
    pdf.setLineWidth(y);
    
    autoTable(pdf,{
        body: body,
        columns: columns,
        startY: 80,
        margin: {
          left: 5,
        },
        styles: {font: 'helvetica', minCellHeight: 50 }, // overflow: "ellipsize",

        // foot:[[' ', 'Price total', '130000', '  ']],
        headStyles :{textColor: [255, 255, 255], minCellHeight:30,overflow: "linebreak",},
        footStyles :{textColor: [255, 255, 255],},
        
        theme: 'grid',
        columnStyles: {
            0: {halign: 'right', cellWidth: 40,},
            1: {halign: 'left', cellWidth: 200,},
            2: {halign: 'right', cellWidth: 70,},
            3: {halign: 'center', cellWidth: 30,},
            4: {halign: 'left', cellWidth: 310,},
            5: {halign: 'right', cellWidth: 60,},
            6: {halign: 'right', cellWidth: 60,},
            7: {halign: 'right', cellWidth: 60,},
            8: {halign: 'right', cellWidth: 60,},
        },
    })       
      pdf.output('dataurlnewwindow');
  }
}
